import { ResetPasswordPage } from '@/components/pages/reset-password/ResetPasswordPage'

export default ResetPasswordPage
